export default "__VITE_ASSET__DvCCYB$q__"